import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, CUSTOM_ELEMENTS_SCHEMA, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
// Removed WidgetModule import to break circular dependency
// CommonWidgetComponent is NOT standalone, so we can't import it directly
// Solution: Comment out widget usage in template or convert CommonWidgetComponent to standalone
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CandidateCardTableViewComponent } from '../candidate-card-table-view/candidate-card-table-view.component';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateCardComponent } from '../../cards/candidate-card/candidate-card.component';
// Direct import. NewJobComponent transitively imports this component, so
// the import cycle is broken with `forwardRef(() => NewJobComponent)` in
// the @Component imports array — TS-level compilation would otherwise
// resolve one side of the cycle to undefined at module-load time.
import { NewJobComponent } from 'src/app/page/homepage/layout-jobs/new-job/new-job.component';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-talent-pool',
  standalone: true,
  imports: [CommonModule, FormsModule, InfiniteScrollModule,
CandidateCardTableViewComponent, CommonSkeletonComponent, CandidateCardComponent,
    NgIconComponent,
    forwardRef(() => NewJobComponent),
  ],
  providers: [provideIcons(APP_ICONS)],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './talent-pool.component.html',
  styleUrls: ['./talent-pool.component.scss']
})
export class TalentPoolComponent implements OnInit, OnChanges, OnDestroy {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.talent-pool-container')),
  });

  @Input() jobDetails: any;
  @Input() showSuggJobsDataServer: any = [];
  @Input() designVersion: string = 'v2';
  @Output() parentValueChange = new EventEmitter<any>();

  @ViewChild('jobsupplytemplate') jobSupplyTemplate: TemplateRef<any>;

  userType: any = localStorage.getItem('userType');
  userId: any;
  url = AppSettings.photoUrl;

  // Data properties
  response: any = [];
  pageNumber: number = 0;
  stopscrollFlag: boolean = false;
  loadAPIcall: boolean = false;
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;
  responseReceived: boolean = false;

  // Stage counts
  stageCounts = {
    all: 0,
    sourced: 0,
    reachedOut: 0,
    engaged: 0,
    qualified: 0
  };

  // Header stat-grid values sourced from /jobs/findTalentPoolMatches response
  // (totalCount / immediateAvailableCount / averageScore). Populated on the
  // first page only so paginated scrolls don't overwrite pool-level totals.
  talentPoolTotal: number = 0;
  immediateAvailableCount: number = 0;
  averageScore: number = 0;

  // Filter & Search
  searchText: string = '';
  searchExpanded: boolean = true;
  selectedStage: any;
  activeFiltersCount: number = 0;

  // Subscriptions
  private subscriptions: Subscription[] = [];

  constructor(
    private apiService: ApiService,
    private util: UtilService,
    private router: Router,
    private candidateService: CandidateService, private modalService : NgbModal,
    private planService : PricePlanService, private bsModalService: BsModalService
  ) { }

  ngOnInit() {


    this.scrollGate.attach();
    this.userId = localStorage.getItem('userId');
    console.log('[TalentPool] ngOnInit - userId:', this.userId, 'jobDetails:', this.jobDetails);

    this.subscriptions.push(this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      this.loadTalentPoolDataEnhanced();
    }));

    // Only initialize if jobDetails is already available
    if (this.jobDetails?.jobId) {
      console.log('[TalentPool] Initializing with existing jobDetails');
      this.initializeComponent();
    } else {
      console.log('[TalentPool] Waiting for jobDetails via ngOnChanges');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobDetails?.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      console.log('[TalentPool] ngOnChanges - New jobDetails received:', this.jobDetails);
      this.pageNumber = 0;
      this.response = [];
      this.stopscrollFlag = false;
      this.payload.searchAfterKey = null;
      // Invalidate any in-flight page fetch — a tab re-click during
      // pagination must not let the stale response append into the
      // cleared list or overwrite the reset searchAfterKey.
      this.fetchGeneration++;
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.loadTalentPoolDataEnhanced();
    }
  }

  ngOnDestroy(): void {


    this.scrollGate.detach();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  initializeComponent() {
    console.log('[TalentPool] initializeComponent called');
    this.checkCeipalFreePlan();
    this.payload.searchAfterKey = null;
    this.loadTalentPoolDataEnhanced();
  }

  private checkCeipalFreePlan(): void {
    const membershipType = localStorage.getItem('MemberShipType');
    if (this.jobDetails?.source === 'CEIPAL' && membershipType === 'Free') {
      Swal.fire({
        icon: 'info',
        title: '',
        text: 'AI features are not available for CEIPAL Free plan. Please upgrade your plan to access AI-powered recommendations.',
        showConfirmButton: true,
        confirmButtonText: 'OK'
      });
    }
  }

  payload = {
    // userId: '',
    // organisationId: '',
    limit: 10,
    jobId: '',
    searchAfterKey: null,
    groupType:'TALENT_POOL',
    populate: 'user' // Request user details including workExperience
  };

  // Load talent pool candidates
  loadTalentPoolData() {
    if (!this.jobDetails?.jobId) {
      console.warn('[TalentPool] No jobDetails.jobId available');
      return;
    }

    this.payload.jobId = this.jobDetails.jobId;
    // this.payload.userId = localStorage.getItem('userId') || '';
    // this.payload.organisationId = localStorage.getItem('organisationId');

    this.responseReceived = false;
    this.loadAPIcall = true;

    console.log('[TalentPool] API Call with payload:', this.payload);

    const sub = this.apiService.create('jobs/get-candidates-paginated', this.payload).subscribe(
      res => {
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.responseReceived = true;

        console.log('[TalentPool] API Response:', res);

        const candidates = res.data?.candidates || [];
        console.log('[TalentPool] Received candidates:', candidates.length);
        if(candidates.length > 0){
          this.processCandidates(candidates);
          // this.payload.searchAfter = res?.data?.nextSearchAfter;
        }else {
          this.stopscrollFlag = true;
        }
      },
      err => {
        console.error('[TalentPool] API Error:', err);
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.responseReceived = true;
        this.stopscrollFlag = true;
      }
    );

    this.subscriptions.push(sub);
  }
  loadTalentPoolDataEnhanced() {
    if (!this.jobDetails?.jobId) {
      console.warn('[TalentPool] No jobDetails.jobId available');
      return;
    }

    // Prevent API call for Draft status jobs — mirrors Marketplace
    // Candidates (suggested-candidates-ai-list getListOfCandidates).
    // loadAPIcall=false + empty response → "No Talent Pool Yet" empty
    // state shows directly, no AI-analyzing state, no fetch.
    const jobStatus = this.jobDetails?.status?.toUpperCase();
    if (jobStatus === 'DRAFT' || jobStatus === 'DRAFTED') {
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.responseReceived = true;
      this.stopscrollFlag = true;
      return;
    }

    this.payload.jobId = this.jobDetails.jobId;
    // this.payload.userId = localStorage.getItem('userId') || '';
    // this.payload.organisationId = localStorage.getItem('organisationId');

    this.responseReceived = false;
    this.loadAPIcall = true;
    const gen = this.fetchGeneration;

    console.log('[TalentPool] API Call with payload:', this.payload);

    // Use retry mechanism: 3 retries with 25s delay = ~75s total
    const isFirstPage = !this.payload.searchAfterKey;
    const sub = this.apiService.talentPoolWithRetry('jobs/findTalentPoolMatches', this.payload).subscribe({
      next: (res) => {
        if (gen !== this.fetchGeneration) return;
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.responseReceived = true;

        console.log('[TalentPool] API Response:', res);

        if (isFirstPage) {
          this.talentPoolTotal = res?.totalCount ?? 0;
          this.immediateAvailableCount = res?.immediateAvailableCount ?? 0;
          this.averageScore = res?.averageScore ?? 0;
        }

        const candidates = res?.candidateList || [];
        console.log('[TalentPool] Received candidates:', candidates.length);
        if(candidates.length > 0){
          this.processCandidates(candidates);
          this.payload.searchAfterKey = res?.searchAfterKey;
        }else {
          this.stopscrollFlag = true;
        }
      },
      error: (err) => {
        if (gen !== this.fetchGeneration) return;
        console.error('[TalentPool] API Error:', err);
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.responseReceived = true;
        this.stopscrollFlag = true;

        // Handle processing timeout (after max retries exhausted)
        if (err.timeout && err.isProcessing) {
          // Swal.fire({
          //   title: 'Analysis In Progress',
          //   text: err.message || 'The AI is analyzing talent pool candidates. This may take a moment. Please try again shortly.',
          //   icon: 'warning',
          //   confirmButtonText: 'OK'
          // });
          console.error('Failed to fetch talent pool candidates:', err);
        } else {
          // Other errors - silent handling, just log
          console.error('Failed to fetch talent pool candidates:', err);
        }
      }
    });

    this.subscriptions.push(sub);
  }

  async processCandidates(candidates: any[]) {
    console.log('[TalentPool] processCandidates - Input:', candidates.length, 'candidates');
    console.log('[TalentPool] processCandidates - Current response length:', this.response.length);

    if (candidates.length === 0) {
      this.stopscrollFlag = true;
      console.log('[TalentPool] No candidates received, stopscrollFlag set to true');
    } else {
      if (candidates.length < 9) {
        this.stopscrollFlag = true;
        console.log('[TalentPool] Less than 9 candidates, stopscrollFlag set to true');
      } else {
        this.stopscrollFlag = false;
        this.pageNumber++;
        console.log('[TalentPool] More candidates available, pageNumber incremented to:', this.pageNumber);
      }

      // Enrich candidates with full user details if missing
      // const enrichedCandidates = await this.enrichCandidatesWithUserDetails(candidates);

      const combinedCandidates = [...this.response, ...candidates];
      const uniqueCandidatesMap = new Map(combinedCandidates.map(candidate => [candidate.candidateId, candidate]));
      this.response = Array.from(uniqueCandidatesMap.values());

      console.log('[TalentPool] processCandidates - Final response length:', this.response.length);
      console.log('[TalentPool] processCandidates - Sample candidate:', this.response[0]);
    }
  }

  // Enrich candidates with full user details including workExperience and connectionStatus
  async enrichCandidatesWithUserDetails(candidates: any[]): Promise<any[]> {
    const enrichmentPromises = candidates.map(async (candidate) => {
      // Check if user object is missing or incomplete
      if (!candidate.user || !candidate.user.workExperience) {
        try {
          console.log('[TalentPool] Fetching full details for candidate:', candidate.candidateId);
          const response = await this.apiService.query(`candidates/findCandidateById/${candidate.candidateId}`).toPromise();

          if (response && response.code === '00000' && response.data?.candidateData) {
            // Merge the enriched data with existing candidate data
            return {
              ...candidate,
              ...response.data.candidateData,
              // Preserve any specific fields from the original response
              matchScore: candidate.matchScore,
              rank: candidate.rank,
              score : candidate.score
            };
          }
        } catch (error) {
          console.error('[TalentPool] Error enriching candidate:', candidate.candidateId, error);
        }
      }

      return candidate;
    });

    return Promise.all(enrichmentPromises);
  }

  // Select stage tab
  selectStage(stage: string) {
    this.selectedStage = stage;
    this.pageNumber = 0;
    this.response = [];
    this.stopscrollFlag = false;
    this.payload.searchAfterKey = null;
    this.loadTalentPoolDataEnhanced();
  }

  // Search functionality
  filterCandidates() {
    if (this.searchText === '' || this.searchText.trim() !== '') {
      this.pageNumber = 0;
      this.response = [];
      this.stopscrollFlag = false;
      this.payload.searchAfterKey = null;
      this.loadTalentPoolDataEnhanced();
    }
  }

  toggleSearch() {
    // this.searchExpanded = !this.searchExpanded;
    if (this.searchExpanded) {
      setTimeout(() => {
        const searchInput = document.getElementById('talent_pool_search') as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 300);
    }
  }

  onSearchFocus() {
    this.searchExpanded = true;
  }

  onSearchBlur() {
    if (!this.searchText || this.searchText.trim() === '') {
      setTimeout(() => {
        // this.searchExpanded = false;
      }, 200);
    }
  }

  // Filter slider
  openFilterSlider() {
    // Implement filter slider logic
    console.log('Open filter slider');
  }

  // Infinite scroll
  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }

  // Action handlers
  route(candidate: any) {
    this.router.navigate(['newcandidates'], {
      queryParams: { candidateId: candidate.candidateId, tabName: 'profileSummary' }
    });
  }

  open(candidate: any) {
    this.util.startLoader();
    this.candidateService.updateCandidateViewed(candidate).subscribe(
      res => {
        this.util.stopLoader();
      },
      err => {
        this.util.stopLoader();
      }
    );
  }

  // Intentional no-op — the child `app-candidate-card-table-view` owns
  // the resume-download flow end-to-end (plan-check via
  // ACTIVE_INTERACTIONS, then registered blob download via
  // `candidates/resumeDownload/...`). The previous body opened
  // `this.url + fileId` directly, bypassing plan-gating entirely. See
  // candidate-card-table-view.component.ts:416-466 for the correct
  // flow. Leave body empty — child handles everything.
  downloadResume(candidate: any): void {
    // No-op on purpose. See comment above.
  }

  sendMessage(candidate: any) {
    // Implement messaging logic
    console.log('Send message to:', candidate);
  }

  openDocuments(candidate: any) {
    // Implement documents logic
    console.log('Open documents for:', candidate);
  }

  shareProfile(candidate: any) {
    // Implement share logic
    console.log('Share profile:', candidate);
  }

  scheduleInterview(candidate: any) {
    // Implement interview scheduling
    console.log('Schedule interview with:', candidate);
  }

  addNotes(candidate: any) {
    // Implement notes functionality
    console.log('Add notes for:', candidate);
  }

  updateStatus(status: any, candidate: any) {
    // Implement status update
    console.log('Update status:', status, candidate);
  }

  updatetocandidateActivity(event: any) {
    this.parentValueChange.emit(event);
  }

  reasons: any[] = [];
  candidateScore:any;
  private retryAttempt: number = 0;

  showDetails(item:any, modal:any){
    console.log('item: ', item);
    let payload = {
      sourceEntityId : this.jobDetails.jobId,
      targetEntityId : item.candidateId,
      type : 'JOB',
      groupType : 'APPLICANT_JOB'
    }
    // Don't use util.startLoader() - it blocks entire app during AI processing
    this.reasons = [];
    this.candidateScore = null;
    this.retryAttempt = 0;

    // Use default retry settings: 3 retries with 25s delay = ~75s total
    this.apiService.fetchRankingDetailsWithRetry(payload).subscribe({
      next: (res) => {
        if(res.code == '00000'){
          // Handle both old format (ranking) and new format (rankings array)
          let ranking = null;

          if (res.data.ranking) {
            // Old format: single ranking object
            ranking = res.data.ranking;
          } else if (res.data.rankings && res.data.rankings.length > 0) {
            // New format: rankings array
            const firstRanking = res.data.rankings[0];
            if (firstRanking.targetEntities && firstRanking.targetEntities.length > 0) {
              const targetEntity = firstRanking.targetEntities[0];
              // Merge ranking data with targetEntity data
              ranking = {
                ...firstRanking,
                targetEntityId: targetEntity.targetEntityId,
                score: targetEntity.score,
                reason: targetEntity.reason || firstRanking.reason,
                strengths: targetEntity.strengths || firstRanking.strengths || [],
                weaknesses: targetEntity.weaknesses || firstRanking.weaknesses || [],
                updatedOn: targetEntity.updatedOn || firstRanking.updatedOn
              };
            }
          }

          if(ranking){
            // Build reasons array from the ranking object
            this.reasons = [{
              targetEntityId: ranking.targetEntityId,
              score: ranking.score,
              reason: ranking.reason,
              strengths: ranking.strengths || [],
              weaknesses: ranking.weaknesses || [],
              updatedOn: ranking.updatedOn
            }];

            this.candidateScore = ranking.score + '%';
            this.openModal(modal);
          }else {
            Swal.fire('No ranking details available','','info');
          }
        }else {
          Swal.fire('Something went wrong','','error');
        }
      },
      error: (err) => {

        // Handle processing timeout
        if (err.timeout && err.isProcessing) {
          Swal.fire({
            title: 'Analysis In Progress',
            text: err.message || 'The AI analysis is taking longer than expected. Please try again in a moment.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
        } else if (err.isProcessing) {
          // Retry in progress - show loading message
          this.retryAttempt++;
          Swal.fire({
            title: 'Analyzing Match...',
            html: `AI is analyzing candidate compatibility.<br><small>Attempt ${this.retryAttempt}/3</small>`,
            icon: 'info',
            timer: 2500,
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        } else {
          // Other errors
          Swal.fire('Something went wrong','','error');
        }
      }
    });
  }

  openModal(modalName: any){
    try {
      this.modalService.open(modalName, {size: 'md', centered: true}).result.then((result) => {
        console.log('Modal closed with result:', result);
      }, (reason) => {
        console.log('Modal dismissed with reason:', reason);
      });
    } catch (error) {
      console.error('Error opening modal:', error);
      Swal.fire('Error', 'Failed to open modal', 'error');
    }
  }

  closeModal(){
    this.modalService.dismissAll();
  }

  closeJobSupplyModal() {
    if (this.candidateSupplyRef) {
      this.candidateSupplyRef.hide();
    }
  }

  isClicked: boolean = false;
  candidateData: any;
  focus: string;
  invite(values: any) {
    console.log('invite button clicked', values);

    if (this.isClicked) {
      return;
    }

    this.util.startLoader();
    this.isClicked = true;
    this.candidateData = values;
    this.focus = 'candidate';

    // this.checkConnectionStatus(values)
    //   .subscribe(response => {
        //if (values.isFeatured == true) {
          this.proceedToInvite(values, this.jobSupplyTemplate);
       // } else if (values.isFeatured == false || values.isFeatured == null) {
          // if (response.data.connectionStatus === 'CONNECTED') {
          //   this.proceedToInvite(values, this.jobSupplyTemplate);
          // } else if (response.data.connectionStatus !== 'CONNECTED') {
          //   this.proceedToInvite(values, this.jobSupplyTemplate);
            // to be used later
            // this.openConnectionTemplate(response.data.connectionStatus, values, connectionModal);
          //}
      //  }
      //})
      setTimeout(() => {
        this.isClicked = false;
      }, 5000);
  }

    candidateSupplyRef: BsModalRef;
    
    async proceedToInvite(values, jobsupplytemplate) {
        this.util.startLoader();
        const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
        let {membershipType } = userData;
        if (userData.isExpired) {
          this.util.stopLoader();
          let availablePoints = null;
          let actualPoints = null;
          let utilizedPoints = null;
          let promotional = null;
          userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
            if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
              this.util.stopLoader();
              availablePoints = ele.available
              actualPoints = ele.actual
              utilizedPoints = ele.utilized
              promotional = ele.promotional
            }
          })
          let popupType: "PAY" | "LIMIT"   | "UPGRADE" = "PAY";
    
          if (['Starter','Growth','ScaleX'].includes(membershipType)) {
            popupType = "LIMIT";
          }
          this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);
    
          return;
        }
        values.userId = localStorage.getItem('userId');
        values.candidatefilter = true;
        values.getResume = false;
        values.userType = values.user ? values.user.userType : null;
        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.bsModalService.show(jobsupplytemplate, config);
        this.util.stopLoader();
      }

  // Helper method to set rank on candidate object for row-design view
  setRankAndShowSkills(item: any, rank: number): any {
    // Modify the item in place to avoid creating new object references
    if (item.showAllSkills === undefined) {
      item.showAllSkills = false;
    }
    item.rank = rank;
    return item;
  }

  // AI Processing message logic - copied from candidate-card-table-view
  get noResultMessage(): string {
    if (!this.responseReceived) {
      return 'Our AI is building your talent pool by analyzing candidates from your network, previous interactions, and job applicants...';
    } else {
      return 'No candidates in your talent pool yet. Our AI is processing this job and analyzing your network connections, previous interactions, and applicants to find the best matches. Please check back soon!';
    }
  }

  get noResultSvgType(): string {
    // Always show AI processing icon for AI-powered talent pool
    return 'customAiProcessing';
  }
}

